"use client";

import {
  type AddToCartLineItem,
  buildAddToCartEcommercePayload,
  buildEcommerceEvent,
} from "@/lib/analytics/ecommerce-analytics";
import { getItemListOrigin } from "@/lib/analytics/item-list-context";

import { EVENTS } from "@/constants/analytics.constants";
import { useTagging } from "@/hooks/useTagging";

export function useAddToCartAnalytics({
  kits,
  accessories,
  monitoring,
}: UseAddToCartAnalyticsOptions) {
  const [, setTag] = useTagging();

  return () => {
    const origin = getItemListOrigin();
    const payload = buildAddToCartEcommercePayload(
      { kits, accessories, monitoring },
      {
        item_list_id: origin?.item_list_id,
        item_list_name: origin?.item_list_name,
      },
    );

    setTag(buildEcommerceEvent(EVENTS.ADD_TO_CART, payload), { reset: true });
  };
}

type UseAddToCartAnalyticsOptions = {
  kits: AddToCartLineItem[];
  accessories: AddToCartLineItem[];
  monitoring: AddToCartLineItem | null;
};
